<template>
  <div class="systemDoor">
    <div class="systemDoorBox">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-bottom: 20px">
        <el-tab-pane label="检查项" name="checkOption"></el-tab-pane>
        <el-tab-pane label="问卷分类" name="category"></el-tab-pane>
      </el-tabs>

      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">名称</span>
          <el-input
            v-model="filterData.name"
            placeholder=""
            style="width: auto"
          ></el-input>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
          <el-button
            plain
            round
            icon="el-icon-upload2"
            size="small"
            style="color: #67C23A"
            @click="openEdit(null)">
            新 建
          </el-button>
        </el-col>
        <!--        <el-col :span="2">-->
        <!--          <el-button-->
        <!--            plain-->
        <!--            round-->
        <!--            icon="el-icon-download"-->
        <!--            size="small"-->
        <!--            style="color: #67C23A"-->
        <!--            @click="exportExcel"-->
        <!--          >-->
        <!--            导 出-->
        <!--          </el-button>-->
        <!--        </el-col>-->
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="name"
          label="名称"
        ></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row)"
            >编辑</el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="onDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>

    <el-dialog
      title="新增/编辑 问卷分类"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div>
        <el-form :model="form">
          <el-form-item label="分类名称" label-width="120px">
            <el-input style="width: 300px" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="save()" round >提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "SystemManageTwo",
  data() {
    return {
      activeName: "category",
      dialogVisible: false,
      currentId: '',
      filterData: {},
      initialFilterData: {
        name: "" //搜索项
      },
      form: {
        name: '',
      },
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData();
    this.clearFilter();
  },
  methods: {
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
    },
    handleClick(tab, event){
      if (tab.name === "checkOption"){
        this.$router.push("/opr/systemManageOne")
      }
    },
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign({}, this.tableConfig, this.filterData);
      let res = await axios.post(oprReqUrl+"/surveyclass/search", params);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openEdit(row) {
      this.dialogVisible = true
      if (row) {
        this.form = row
        this.currentId = row.id
      } else {
        this.form = {
          name: '',
        }
        this.currentId = null
      }
    },
    async onDelete(id) {
      this.$confirm("确认删除吗？", "提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let res = await axios.post(oprReqUrl+"/surveyclass/delete", {id});
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          }else {
            this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },
    async save() {
      const params = _.assign(this.form, { id: this.currentId });
      let res = await axios.post(oprReqUrl+"/surveyclass/save", params);
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message)
        this.getData();
        this.dialogVisible = false
      }
      this.tableLoading = false;
    },
  }
};
</script>
<style lang="sass" scoped>
.systemDoor
  min-width: 1050px
  input[type=file]
    display: none
  .systemDoorBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/systemManageTwo.vue